import React from 'react';
import GitHubCalendar from 'react-github-calendar';

const GitHubContributionsCalendar = ({ username }) => {
  const theme = {
    dark: ['#1e2327', '#ffff00'] // Dark theme with green color
  };

  return (
    <div className="hidden lg:block"> {/* Hide on screens smaller than lg */}
      <div className="flex justify-center items-center">
        <div className="bg-gray-900 p-4 lg:p-8 rounded-lg shadow-lg">
          <h2 className="text-lg lg:text-2xl font-bold text-white mb-4">GitHub Contributions Calendar</h2>
          <GitHubCalendar
            username={username}
            blockMargin={4}
            blockRadius={2}
            blockSize={15} // Adjust block size for smaller screens
            colorScheme="dark"
            fontSize={12} // Adjust font size for smaller screens
            hideColorLegend={false}
            hideMonthLabels={false}
            hideTotalCount={false}
            loading={false}
            showWeekdayLabels={false}
            style={{ marginBottom: '1rem', maxWidth: '100%' }} // Make sure calendar doesn't overflow on small screens
            theme={theme}
            throwOnError={false}
            weekStart={0}
          />
          <p className="text-white text-sm lg:text-base">
            Made with love by <a href={`https://github.com/${username}`}  target="_blank" rel="noopener noreferrer" className="font-bold underline">@{username}</a> ❤️
          </p>
        </div>
      </div>
    </div>
  );
}

export default GitHubContributionsCalendar;
